import { Link, useNavigate } from 'react-router-dom';
import type { Episode } from '@/mocks/episodes';

interface EpisodeSwitcherProps {
  episodes: Episode[];
  currentId: string;
}

export default function EpisodeSwitcher({ episodes, currentId }: EpisodeSwitcherProps) {
  const navigate = useNavigate();
  return (
    <div>
      <label className="block text-xs text-foreground-500 mb-2">快速切换集数</label>
      <select
        value={currentId}
        onChange={(e) => {
          const value = e.target.value;
          if (value && value !== currentId) {
            navigate(`/play/${value}`);
          }
        }}
        className="w-full h-11 px-3 rounded-md bg-background-50 border border-background-200 text-sm text-foreground-900 focus:outline-none focus:border-primary-300"
      >
        {episodes.map((episode) => (
          <option key={episode.id} value={episode.id} disabled={!episode.aired}>
            第 {episode.number} 集 · {episode.title}
            {episode.aired ? '' : '（待更新）'}
          </option>
        ))}
      </select>

      <div className="mt-5 grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-4 gap-2">
        {episodes.map((episode) => {
          const active = episode.id === currentId;
          if (!episode.aired) {
            return (
              <span
                key={episode.id}
                className="h-10 rounded-md flex items-center justify-center text-xs font-label border border-dashed border-background-300 text-foreground-400 cursor-not-allowed"
                title={`第${episode.number}集 待更新`}
              >
                {episode.number}
              </span>
            );
          }
          return (
            <Link
              key={episode.id}
              to={`/play/${episode.id}`}
              className={`h-10 rounded-md flex items-center justify-center text-xs font-label border transition-colors ${
                active
                  ? 'bg-primary-500 border-primary-500 text-background-50 dark:text-foreground-950'
                  : 'bg-background-50 border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
              }`}
              title={episode.title}
            >
              {episode.number}
            </Link>
          );
        })}
      </div>
    </div>
  );
}